<template>
  <div class="register-box card-1">
    <!-- <div class="alert alert-danger">
          <strong>Application is closed for the June 2019 Doctoral School</strong>
       </div> -->
  <div class="register-box-body">
       <!-- <img src="assets/images/logopada_0.png" alt="" style="max-height:60px;display:block;margin:auto"> -->
       <img src="assets/images/icon.png" alt="" style="max-height:60px;display:block;margin:auto">
      <p style="text-align:center;font-weight:bold">DEPARTMENT OF NUTRITION AND FOOD SCIENCE UNIVERSITY OF GHANA
        
      </p>
    <p class="login-box-msg">Sign up to Apply</p>

    <form @submit.prevent="signup">
      <div class="form-group has-feedback" style="margin-bottom:0px">
        <input v-validate="'required'" name="surname" type="text" class="form-control" placeholder="Surname" v-model="formdata.surname" data-vv-as="Surname">
        <span class="fa fa-user form-control-feedback"></span>
      </div>
      <span style="color:red;font-style:italic;text-align:center">{{ errors.first('surname') }}</span>
        <br>
       <div class="form-group has-feedback" style="margin-bottom:0px">
        <input v-validate="'required'" name="othernames" type="text" class="form-control" placeholder="Othernames" v-model="formdata.othernames" data-vv-as="Othernames">
        <span class="fa fa-user form-control-feedback"></span>
      </div>
        <span style="color:red;font-style:italic">{{ errors.first('othernames') }}</span>
        <br>

      <div class="form-group has-feedback" style="margin-bottom:0px">
        <input v-validate="'required|email'" name="email" type="email" class="form-control" placeholder="Email" v-model="formdata.email" data-vv-as="Email">
        <span class="fa fa-envelope form-control-feedback"></span>
      </div>
      <span style="color:red;font-style:italic">{{ errors.first('email') }}</span>
        <br>

      <div class="form-group has-feedback" style="margin-bottom:0px">
        <input v-validate="'required'" ref="password" name="password" type="password" class="form-control" placeholder="Password" v-model="formdata.password" data-vv-as="Password">
        <span class="fa fa-lock form-control-feedback"></span>
      </div>
        <span style="color:red;font-style:italic">{{ errors.first('password') }}</span>
        <br>

      <div class="form-group has-feedback" style="margin-bottom:0px">
        <input v-validate="'required|confirmed:password'" name="cfmpassword" type="password" class="form-control" placeholder="Retype password" data-vv-as="Confirm Password">
        <span class="fa fa-lock form-control-feedback"></span>
      </div>
        <span style="color:red;font-style:italic">{{ errors.first('cfmpassword') }}</span>
        <br>

      <div class="row">
        <!-- /.col -->
        <div class="col-xs-12">
          <button :disabled="toggledisabled" type="submit" class="btn btn-primary btn-block btn-flat" style="display:block;margin:auto">Register <img v-show="toggledisabled" src="assets/images/loading.gif" style="max-height: 20px"></button>
        </div>
        <!-- /.col -->
      </div>
    </form>
    <br>
    <router-link to="/login">Already having accounts? Click to Login</router-link>
  </div>
  <!-- /.form-box -->
</div>
</template>

<script>
export default {
  name: 'Signup',
  data:function(){
      return {
          toggledisabled:false,
          formdata:{
              surname:'',
              othernames:'',
              email:'',
              password:''
          }
      }
  },
  methods: {
      signup:function(){
           this.$validator.validate().then(valid => {
                if (valid) {
          this.toggledisabled = true;
          var _this = this; 
          this.$http.post(this.appenv.baseurl+'/createuser',_this.formdata).then((result)=>{
               _this.toggledisabled = false;
              if(result.data.status==='success'){
                  //this.$swal('Success','Your accounts created successfully','success');
                  localStorage.setItem('user',JSON.stringify(result.data.user));
                  localStorage.setItem('apikey',result.data.apikey);
                  this.$router.push('apply');
                  
              }else if(result.data.status==='exists'){
                    this.$swal('Oops','An Account has already been created with this email.. Please login instead','error');
              }else{
                   this.$swal('Oops','Sorry,Your account could not be created','error');
              }
          }).catch(()=>{
              _this.toggledisabled = false;
              this.$swal('Oops','Sorry,Your account could not be created','error');
             // console.log(err)
          });
      }
           }).catch(()=>{
              // console.log(err);
           });
  },
  created:function() {
   // console.log(this.$toastr);
  },
}
}
</script>
<style>
    .login-box, .register-box {
    width: 400px;
    height: 100%;
    /* margin: 7% auto 25% auto; */
}

</style>
